<div class="page tracking content">
    <app-left-track [trackingMode]="true"></app-left-track>
    <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
        <span><i></i></span>
    </div>
    <app-right-track></app-right-track>
</div>
